import React from 'react';
import { motion } from 'motion/react';

const AnimatedButton = ({ children, onClick, type = 'button', className = '', style = {}, disabled = false }) => {
    return (
        <motion.button
            type={type}
            onClick={onClick}
            className={className}
            style={style}
            disabled={disabled}
            whileHover={{
                scale: 1.02,
                transition: { duration: 0.2 },
            }}
            whileTap={{
                scale: 0.98,
                transition: { duration: 0.1 },
            }}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
        >
            {children}
        </motion.button>
    );
};

export default AnimatedButton;
